import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Star } from 'lucide-react';
import { wishlistAPI } from '../services/api';
import { toast } from 'sonner';

const ServiceProductCard = ({ item, onAddToCart }) => {
  const navigate = useNavigate();
  const [isInWishlist, setIsInWishlist] = useState(false);
  const [wishlistLoading, setWishlistLoading] = useState(false);
  
  const {
    id,
    name,
    description,
    price,
    currency,
    type,
    images,
    is_premium,
    is_delivery,
    enterprise_id,
    enterprise_name,
    rating,
    review_count,
    available = true
  } = item;

  const handleToggleWishlist = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const token = localStorage.getItem('titelli_token');
    if (!token) {
      toast.error('Connectez-vous pour ajouter aux favoris');
      navigate('/auth');
      return;
    }
    
    setWishlistLoading(true);
    try {
      if (isInWishlist) {
        await wishlistAPI.remove(id);
        setIsInWishlist(false);
        toast.success('Retiré des favoris');
      } else {
        await wishlistAPI.add({
          item_id: id,
          item_type: type,
          item_name: name,
          item_price: price,
          item_image: images?.[0] || '',
          enterprise_id: enterprise_id,
          enterprise_name: enterprise_name
        });
        setIsInWishlist(true);
        toast.success('Ajouté aux favoris !');
      }
    } catch (error) {
      const errorMsg = error.response?.data?.detail;
      if (typeof errorMsg === 'string') {
        toast.error(errorMsg);
      } else if (Array.isArray(errorMsg)) {
        toast.error(errorMsg[0]?.msg || 'Erreur de validation');
      } else {
        toast.error('Erreur lors de l\'ajout aux favoris');
      }
    } finally {
      setWishlistLoading(false);
    }
  };

  const defaultImage = type === 'service' 
    ? 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=800'
    : 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=800';

  // Format rating display
  const displayRating = rating ? `${rating.toFixed(1)} / 5` : '4.5 / 5';
  const displayReviews = review_count || 0;

  return (
    <div 
      className="bg-white border border-gray-100 shadow-sm hover:shadow-lg group rounded-2xl overflow-hidden transition-all"
      data-testid={`item-card-${id}`}
    >
      {/* Image - Clean without overlays */}
      <Link to={`/${type}/${id}`} className="block relative h-44 sm:h-52 overflow-hidden">
        <img
          src={images?.[0] || defaultImage}
          alt={name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </Link>

      {/* Content */}
      <div className="p-4">
        <Link to={`/${type}/${id}`}>
          <h3 className="text-base font-semibold text-gray-900 group-hover:text-[#D4627F] transition-colors mb-1 line-clamp-1">
            {name}
          </h3>
        </Link>

        <p className="text-sm text-gray-500 mb-3 line-clamp-2">
          {description}
        </p>



      
      </div>
    </div>
  );
};

export default ServiceProductCard;
